export function titleCase(str, separator) {
    let newStr
    if (str.value === 'onhold') newStr = 'On Hold'
    else if (str.value === 'notshown') newStr = 'manual ship'
    else if (str.value === 'forpickup') newStr = 'for pickup'
    else if (str.value === 'intransit') newStr = 'in transit'
    else newStr = str.value

    let splitStr = newStr?.toLowerCase()?.split(separator || ' ');
    for (let i = 0; i < splitStr?.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i]?.charAt(0)?.toUpperCase() + splitStr[i]?.substring(1);
    }
    // Directly return the joined string
    return splitStr?.join(' ');
}